import "lib/cesium-init"; // must be first — sets CESIUM_BASE_URL before Cesium loads
import "@stripe/stripe-js"; //advanced fraud protection
import "../styles/globals.css";

import { AppType } from "next/dist/shared/lib/utils";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import AuthProvider from "components/auth/AuthProvider";
import CesiumViewerHost from "components/elements/CesiumViewer/CesiumViewerHost";
import ToastContainer from "components/elements/Toast/ToastContainer";
import LayoutRouter from "components/layouts/LayoutRouter";
import GlobalProviders from "lib/contexts/GlobalContexts/GlobalProviders";
import ProviderRouter from "lib/contexts/ProjectContexts/ProviderRouter";
import SpatialProviders from "lib/contexts/SpatialContexts/SpatialProviders";
import GlobalErrorBoundary from "components/error-boundaries/GlobalErrorBoundary";

const App: AppType = ({ Component, pageProps }) => (
  <>
    <AuthProvider>
      <GlobalErrorBoundary>
        <GlobalProviders>
          <SpatialProviders>
            <ProviderRouter>
              <LayoutRouter>
                <Component {...pageProps} />
              </LayoutRouter>
            </ProviderRouter>
            <CesiumViewerHost />
          </SpatialProviders>
        </GlobalProviders>
      </GlobalErrorBoundary>
    </AuthProvider>
    <ToastContainer />
  </>
);

export default withLDProvider({
  clientSideID: globalThis.__ENV?.RUNTIME_PUBLIC_LAUNCH_DARKLY_CLIENT_KEY,
})(App);
